import React, { Component } from "react";

import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import "react-google-places-autocomplete/dist/assets/index.css";
import { geocodeByPlaceId, getLatLng } from "react-google-places-autocomplete";
import "./editor-autocomplete.css";

import i18n from "i18next";

export default class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this._autocomplete = React.createRef();
    this.state = {};
    this._textInput = React.createRef();
    this.ukraineBounds = {
      west: 22.13722,
      east: 40.22806,
      north: 52.37917,
      south: 44.38722,
    };
  }

  getAddress(place) {
    let idx = 0;
    let city;
    let country;

    for (let address of place.address_components) {
      idx++;
      if (idx === 1) {
        city = address.long_name;
      }

      if (address.types.indexOf("country") > -1) {
        country = address.long_name;
      }
    }
    return {
      city,
      country,
    };
  }

  getAddressAndCoordinates(place) {
    return getLatLng(place).then((latLng) => {
      console.log("Got coordinates: ", latLng);
      var address = this.getAddress(place);
      console.log("Got address: ", address);
      if (!address.country) {
        if (
          latLng.lat <= this.ukraineBounds.north &&
          latLng.lat >= this.ukraineBounds.south &&
          latLng.lng <= this.ukraineBounds.east &&
          latLng.lng >= this.ukraineBounds.west
        ) {
          address.country = "Україна";
          try {
            var lang = i18n.language;
            if (lang === "ru") {
              address.country = "Украина";
            }
          } catch (e) {
            (console.error || console.log).call(console, e.stack || e);
          }
        }
      }
      return {
        city: address.city,
        country: address.country,
        latitude: latLng.lat,
        longitude: latLng.lng,
      };
    });
  }
  handleAutocompleteSelect = (address) => {
    console.log(address);
    geocodeByPlaceId(address.place_id)
      .then((results) => {
        console.log("Got places:", results);
        console.log("lat:", results[0].geometry.location.lat());
        return this.getAddressAndCoordinates(results[0]);
      })
      .then((place) => {
        console.log("place:", place);
        place.description = address.description;
        this.props.onPlaceChanged(place);
      })
      .catch((error) => console.error("Error", error));
  };

  onClear = (e) => {
    try {
      this._autocomplete.current.changeValue("");
      this._textInput.current.focus();
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  renderInput = (props) => {
    return (
      <div className="input-group g-brd-primary--focus">
        <input
          {...props}
          className="form-control form-control-md rounded-0"
          type="text"
          placeholder=""
          ref={this._textInput}
        />
        <div className="input-group-append">
          <button
            className="btn input-group-text rounded-0 g-bg-white g-color-gray-light-v1"
            type="button"
            onClick={this.onClear}
          >
            <i className="fa fa-times g-font-size-14"></i>
          </button>
        </div>
      </div>
    );
  };

  render() {
    var autocompletionRequest = {
      types: ["(cities)"],
    };
    return (
      <div>
        <div>
          <GooglePlacesAutocomplete
            initialValue={this.props.initialValue}
            autocompletionRequest={autocompletionRequest}
            onSelect={this.handleAutocompleteSelect}
            renderInput={this.renderInput}
            ref={this._autocomplete}
            suggestionsClassNames={{
              container: "google-places-autocomplete__suggestions-container",
              suggestion: "autocomplete__suggestion",
              suggestionActive: "autocomplete__suggestion--active",
            }}
          />
        </div>
      </div>
    );
  }
}
